/**
 * AI 生文- 新会话
 * @returns
 */

 import {
  Box,
  Flex,
  Center,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { selectUser } from "@/reducer/userslice";

import { useState } from "react";
import { ChatContent } from "@/types/writing";
import ChatTextInput from "@/components/writingComponent/InputComponent3";
import AiSessionItem2 from "@/components/writingComponent/aiSessionItem2";
import HumanSessionItem2 from "@/components/writingComponent/humanSessionItem2";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectCurrentChatList, selectCurrentKnowledgeTopic } from "@/reducer/chatSlice";

const KnowledgeBase = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const user = useAppSelector(selectUser);
  const currentKnowledgeTopic = useAppSelector(selectCurrentKnowledgeTopic);
  const sessionId = currentKnowledgeTopic.id;

  const currentChatList = useAppSelector(selectCurrentChatList);

  const [text, setText] = useState("");

  const updataInputValue = (chatMSg:ChatContent) => {
    // setText(text);
  };
  const updateValue = (text:string) => {
    setText(text);
  };
  const handleSubmit = () => {
    if (!user) {
      toast({ title: "请登录系统", position: "top", status: "error", duration: 1000 });
      return;
    }
    console.log(text, "text2>>>>");
  };


  return (
    <>
      <Flex flexDirection="column" h="100%" maxW={"1028px"} m="0 auto">
        <Box flex={1} h="0" mt="50px" mb="50px">
          <Box h="100%" overflow={"auto"}>
            {currentChatList && currentChatList.map((item, index) => {
              return (
                <Box key={index}>
                  {(item.message_role === "assistant" || item.message_role === "system") && <AiSessionItem2 sessionContent={item} reAnswer={updataInputValue} />}
                  {item.message_role === "user" && (
                    <HumanSessionItem2 sessionContent={item} />
                  )}
                </Box>
              );
            })}
          </Box>
        </Box>
        <Box ml="54px" mb="40px">
          <ChatTextInput
            text={text}
            updateValue={updateValue}
            handleSubmit={handleSubmit}
          />
        </Box>
      </Flex>
    </>
  );
}

export default KnowledgeBase;